import { Box, Button, ListItem } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';
import { Link } from 'react-router-dom';

export const MenuWrapper = styled(Box)(
  ({ theme }) => `
  .MuiList-root {
    padding: ${theme.spacing(1)};
 
    & > .MuiList-root {
      padding: 0 ${theme.spacing(0)} ${theme.spacing(1)};
    }
    background: white;
  }
 
  .MuiListSubheader-root {
    text-transform: uppercase;
    font-weight: bold;
    font-size: ${theme.typography.pxToRem(12)};
    color: ${theme.colors.alpha.trueWhite[50]};
    padding: ${theme.spacing(0, 2.5)};
    line-height: 1.4;
  }`
);

export const SubMenuWrapper = styled(Box)(
  ({ theme }) => `
    .MuiList-root {
      .MuiListItem-root {
        padding: 1px 0;
 
        .MuiBadge-root {
          position: absolute;
          right: ${theme.spacing(3.2)};
 
          .MuiBadge-standard {
            background: ${theme.colors.primary.main};
            font-size: ${theme.typography.pxToRem(10)};
            font-weight: bold;
            text-transform: uppercase;
            color: ${theme.palette.primary.contrastText};
          }
        }
    
        .MuiButton-root {
          display: flex;
          color: ${theme.colors.alpha.trueWhite[70]};
          background-color: transparent;
          width: 100%;
          justify-content: flex-start;
          padding: ${theme.spacing(1.2, 3)};
 
          .MuiButton-startIcon,
          .MuiButton-endIcon {
            transition: ${theme.transitions.create(['color'])};
 
            .MuiSvgIcon-root {
              font-size: inherit;
              transition: none;
            }
          }
 
          .MuiButton-startIcon {
            color: ${theme.colors.alpha.trueWhite[30]};
            font-size: ${theme.typography.pxToRem(20)};
            margin-right: ${theme.spacing(1)};
          }
          
          .MuiButton-endIcon {
            color: ${theme.colors.alpha.trueWhite[50]};
            margin-left: auto;
            opacity: .8;
            font-size: ${theme.typography.pxToRem(20)};
          }
 
          &.active,
          &:hover {
            background-color: ${alpha(theme.colors.alpha.trueWhite[100], 0.06)};
            color: ${theme.colors.alpha.trueWhite[100]};
 
            .MuiButton-startIcon,
            .MuiButton-endIcon {
              color: ${theme.colors.alpha.trueWhite[100]};
            }
          }
        }
 
        &.Mui-children {
          flex-direction: column;
 
          .MuiBadge-root {
            position: absolute;
            right: ${theme.spacing(7)};
          }
        }
 
        .MuiCollapse-root {
          width: 100%;
 
          .MuiList-root {
            padding: ${theme.spacing(1, 0)};
          }
 
          .MuiListItem-root {
            padding: 1px 0;
 
            .MuiButton-root {
              padding: ${theme.spacing(0.8, 3)};
 
              .MuiBadge-root {
                right: ${theme.spacing(3.2)};
              }
 
              &:before {
                content: ' ';
                background: ${theme.colors.alpha.trueWhite[100]};
                opacity: 0;
                transition: ${theme.transitions.create([
                  'transform',
                  'opacity'
                ])};
                width: 6px;
                height: 6px;
                transform: scale(0);
                transform-origin: center;
                border-radius: 20px;
                margin-right: ${theme.spacing(1.8)};
              }
              &.active,
              &:hover {
                &:before {
                  transform: scale(1);
                  opacity: 1;
                }
              }
            }
          }
        }
      }
    }
`
);

export const SidebarMenuWrapper = styled('ul')(() => `
  margin-top: 20px;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
  list-style: none;
`);

export const SidebarSectionTitle = styled('div')(() => `
  color: #9E9E9E;
  font-size: 12px;
  font-weight: 600;
`);

export const SidebarSection = styled('ul')(() => `
  padding: 0;
  margin-left: 7.5px;
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 9px;
`);

export const SidebarItem = styled('li')(() => `
  padding: 4.5px 7.5px;
  border-radius: 8px;
  display: inline-block;

  &.sidebar-selected {
    background: red;
  }
  
  &.sidebar-selected a{
    color: white;
  }
  
  &.sidebar-selected img{
    filter: brightness(0) invert(1);
  }
`);

export const SidebarItemLink = styled(Link)(() => `
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  color: #000000;
`);

export const SidebarDocsSearchWrapper = styled('div')(() => `
  display: flex;
`);

export const SidebarDocsSearchInput = styled('input')(() => `
  fontSize: 12px;
  height: 23px;
  flex: 1;
  border: none;
  background: #E9E9E9;
  padding: 4px 9px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
`);

export const SidebarDocsSearchBtn = styled('button')(() => `
  cursor: pointer;
  background: #EB0A1E;
  border: none;
  width: 27px;
  height: 23px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
`);

export const SidebarDropdown = styled('span')(() => `
  margin-left: auto;
`);


export const SidebarDropdownIcon = styled('img')(() => `
  &.dropdown-open {
    transform: rotate(180deg);
  }
`);

export const DocsBtn = styled(Button)(() => `
  justify-content: flex-start;
  width: 100%;
  text-align: left;
  padding: 4.5px 7.5px;
  border-radius: 8px;

  &.sidebar-selected {
    background: #EB0A1E;
  }
  
  &.sidebar-selected span {
    color: white;
  }
`);

export const ListItemDocs = styled(ListItem)(() => `
  cursor: pointer;
`);

export const SearchDocsWrapper = styled("div")(() => `
  padding-right: 1px;
`);
